import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { PendingOrderService } from '../../services/pending-order.service';
import { Clipboard } from '@capacitor/clipboard';

@Component({
    selector: 'app-reports-pending-orders',
    templateUrl: './reports-pending-orders.page.html',
    styleUrls: ['./reports-pending-orders.page.scss'],
})
export class ReportsPendingOrdersPage implements OnInit {

    pending_orders = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private pendingOrderService: PendingOrderService,
    ) { }

    ngOnInit() {
        this.pendingOrderService.getPendingOrders().then((pending_orders) => {
            if (pending_orders) {
                this.pending_orders = pending_orders;
            }
        })

    }

    copyToClipboard() {
        let orders = JSON.stringify(this.pending_orders);
        Clipboard.write({
            string: orders
        }).then(() => {
        this.presentAlert("Copied to clipboard", "Your pending order data has been copied to your clipboard", "");
        });
    }

    close() {
        this.modalController.dismiss();
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
